import React from 'react'

function AlertsPage() {
    return (
        <>
            <h3>Alerts</h3>
        </>
    )
}

export default AlertsPage;